import(/* webpackMode: "eager", webpackExports: ["Hero"] */ "/home/runner/work/MONADATY/MONADATY/components/Hero.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["FeaturedProducts","CollectionsShowcase","BrandStory","SocialProof","MoroccanMoment","FinalCTA"] */ "/home/runner/work/MONADATY/MONADATY/components/HomepageCommerce.tsx");
